"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _customProps = require("../../utils/customProps");

var _AppBarOffset = _interopRequireDefault(require("./components/AppBarOffset/AppBarOffset"));

var _Storyblok = _interopRequireDefault(require("../../utils/Storyblok"));

var _MuiButtonRedirect = _interopRequireDefault(require("../MuiButtonRedirect/MuiButtonRedirect"));

var _MuiButtonHref = _interopRequireDefault(require("../MuiButtonHref/MuiButtonHref"));

var _MuiIconButtonRedirect = _interopRequireDefault(require("../MuiIconButtonRedirect/MuiIconButtonRedirect"));

var _MuiIconButtonHref = _interopRequireDefault(require("../MuiIconButtonHref/MuiIconButtonHref"));

var _MuiMenu = _interopRequireDefault(require("../MuiMenu/MuiMenu"));

var _MuiButtonDrawer = _interopRequireDefault(require("../MuiButtonDrawer/MuiButtonDrawer"));

var _MuiIconButtonDrawer = _interopRequireDefault(require("../MuiIconButtonDrawer/MuiIconButtonDrawer"));

var _MuiButtonSnackbar = _interopRequireDefault(require("../MuiButtonSnackbar/MuiButtonSnackbar"));

var _MuiActionCardContainer = _interopRequireDefault(require("../MuiActionCardContainer/MuiActionCardContainer"));

var _MuiImage = _interopRequireDefault(require("../MuiImage/MuiImage"));

var _MuiTypography = _interopRequireDefault(require("../MuiTypography/MuiTypography"));

var _MuiContactButton = _interopRequireDefault(require("../MuiContactButton/MuiContactButton"));

var _GoogleConversions = _interopRequireDefault(require("../GoogleConversions/GoogleConversions"));

var _Grid = _interopRequireDefault(require("../Grid/Grid"));

/* eslint-disable max-len */
var MuiAppBar = function MuiAppBar(_ref) {
  var rootClass = _ref.rootClass,
      color = _ref.color,
      position = _ref.position,
      content = _ref.content,
      variant = _ref.variant,
      disableGutters = _ref.disableGutters,
      height = _ref.height;
  var components = {
    MuiButtonRedirect: _MuiButtonRedirect.default,
    MuiButtonHref: _MuiButtonHref.default,
    MuiIconButtonRedirect: _MuiIconButtonRedirect.default,
    MuiIconButtonHref: _MuiIconButtonHref.default,
    MuiMenu: _MuiMenu.default,
    MuiButtonDrawer: _MuiButtonDrawer.default,
    MuiIconButtonDrawer: _MuiIconButtonDrawer.default,
    MuiButtonSnackbar: _MuiButtonSnackbar.default,
    MuiImage: _MuiImage.default,
    MuiActionCardContainer: _MuiActionCardContainer.default,
    MuiTypography: _MuiTypography.default,
    MuiContactButton: _MuiContactButton.default,
    GoogleConversions: _GoogleConversions.default
  };

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass, {
    height: height
  });

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    className: styles.root,
    color: color,
    position: position
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    variant: variant,
    disableGutters: disableGutters
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, content.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_Grid.default, (0, _extends2.default)({}, item, {
      key: index,
      components: components
    }));
  })))), position === 'fixed' && /*#__PURE__*/_react.default.createElement(_AppBarOffset.default, null));
};

var _default = MuiAppBar;
exports.default = _default;
MuiAppBar.propTypes = {
  /**
   * stroyblok multiselect of css classes
   * Override or extend the styles applied to the component.
  */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui props: 'default', 'inherit', 'primary', 'secondary', 'transparent'
   * AppBar: The color of the component. It supports those theme colors that make sense for this component.
   * */
  color: function color(props, propName, componentName) {
    var validProp = ['default', 'inherit', 'primary', 'secondary', 'transparent'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProp);
  },

  /**
   * 'absolute', 'fixed', 'relative', 'static' , 'sticky'
   * AppBar: The positioning type. The behavior of the different options is described in the MDN web docs.
   * Note: sticky is not universally supported and will fall back to static when unavailable.
   * */
  position: function position(props, propName, componentName) {
    var validProp = ['absolute', 'fixed', 'relative', 'static', 'sticky'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProp);
  },

  /**
   * mui prop: 'regular', 'dense'
   * ToolBar: The variant to use.
   *  */
  variant: function variant(props, propName, componentName) {
    var validProp = ['regular', 'dense'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProp);
  },

  /**
   * mui prop: true | false
   * Toolbar: If true, disables gutter padding.
   * */
  disableGutters: _propTypes.default.bool,

  /**
   * Height of the App Bar must use 'px', 'em', '%' 'vh', 'vw', as unit of measurement
   * */
  height: function height(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  },

  /**
   * Content passed to MuiAppBar to render
   * components: 'MuiButtonRedirect',
      'MuiButtonHref',
      'MuiIconButtonRedirect',
      'MuiIconButtonHref',
      'MuiMenu',
      'MuiButtonDrawer',
      'MuiIconButtonDrawer',
      'MuiButtonSnackbar',
      'MuiImage',
      'MuiActionCardContainer',
      'GoogleConversions',
   */
  content: function content(props, propName, componentName) {
    var validComponents = ['MuiButtonRedirect', 'MuiButtonHref', 'MuiIconButtonRedirect', 'MuiIconButtonHref', 'MuiMenu', 'MuiButtonDrawer', 'MuiIconButtonDrawer', 'MuiButtonSnackbar', 'MuiImage', 'MuiActionCardContainer', 'MuiContactButton', 'GoogleConversions'];
    return (0, _customProps.nestedComponentsProps)(props, propName, componentName, validComponents);
  }
};
MuiAppBar.defaultProps = {
  color: 'primary',
  height: '60px',
  position: 'fixed',
  variant: 'regular',
  disableGutters: false,
  rootClass: [],
  content: []
};